// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__22UHR","Label":"BuildControl_Label__3RaSM","Less":"BuildControl_Less__wludS","More":"BuildControl_More__2w720"};